import { zany, zarr, zobj, zstr } from '@/helpers/zodLib';
import type z from 'zod';

export const updateProfileSchema = zobj({
  fname: zstr,
  lname: zstr,
  notifyTo: zarr(zany),
});

export type UpdateProfileSchemaType = z.infer<typeof updateProfileSchema>;

export const updateProfileInitialState: UpdateProfileSchemaType = {
  fname: '',
  lname: '',
  notifyTo: [],
};
